<template>
  <Dialog :commonDialog="dDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Team </v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createContractType"
          >
            <span class="font-size-16 font-weight-600">Add Team</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateContractSetting"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr v-for="(type, index) in localTeams" :key="index">
                      <td>
                        <div class="px-4 py-2">
                          <v-text-field
                            v-model.trim="type.text"
                            dense
                            filled
                            label="Team"
                            solo
                            flat
                            hide-details
                            :disabled="pageLoading"
                            :loading="pageLoading"
                            :rules="[
                              validateRules.required(
                                type.text,
                                'Team Name'
                              ),
                            ]"
                            color="cyan"
                          ></v-text-field>
                          <div class="d-flex mt-2" style="width:100%">
                            <div style="width:50%; padding-right:8px;">
                              <v-select
                                v-model="type.primary_zone"
                                :items="primaryZoneOptions(type)"
                                dense
                                filled
                                label="Primary Zone"
                                solo
                                flat
                                hide-details
                                :disabled="pageLoading || !zoneNames.length"
                                :loading="pageLoading && !zoneNames.length"
                                :rules="[validateRules.required(type.primary_zone, 'Primary Zone')]"
                                color="cyan"
                                multiple
                                @change="onPrimaryChange($event, type)"
                                chips
                              ></v-select>
                            </div>
                            <div style="width:50%; padding-left:8px;">
                              <v-select
                                v-model="type.secondary_zone"
                                :items="secondaryZoneOptions(type)"
                                dense
                                filled
                                label="Secondary Zone"
                                solo
                                flat
                                hide-details
                                :disabled="pageLoading || !zoneNames.length"
                                :loading="pageLoading && !zoneNames.length"
                                color="cyan"
                                multiple
                                @change="onSecondaryChange($event, type)"
                                chips
                              ></v-select>
                            </div>
                          </div>
                        </div>
                      </td>
                      
                      <td width="50" v-if="localTeams.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteContractType(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                     

                  </tbody>
                </table>
                <v-alert
                        v-if="duplicateTeamMessage"
                          type="error"
                          dense
                          outlined
                        >
                        {{ duplicateTeamMessage }}
                  </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading || !formValid || isSaveDisabled"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateContractSetting"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    teams: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    active_zones: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
   
  },
  watch: {
    teams: {
      deep: true,
      immediate: true,
      handler(param) {
        const incoming = Array.isArray(param) ? param : [];
        const mapped = incoming.map((t) => {
          const base = { text: t && t.text ? t.text : null, primary_zone: [], secondary_zone: [] };
          if (Array.isArray(t.primary_zone)) {
            base.primary_zone = t.primary_zone.map((p) => (p && typeof p === "object" ? p.name : p));
          } else if (t.primary_zone) {
            base.primary_zone = [typeof t.primary_zone === "object" ? t.primary_zone.name : t.primary_zone];
          }
          if (Array.isArray(t.secondary_zone)) {
            base.secondary_zone = t.secondary_zone.map((s) => (s && typeof s === "object" ? s.name : s));
          } else if (t.secondary_zone) {
            base.secondary_zone = [typeof t.secondary_zone === "object" ? t.secondary_zone.name : t.secondary_zone];
          }
          return base;
        });
        this.localTeams = mapped.length ? mapped : [{ text: null, primary_zone: [], secondary_zone: [] },];
      },
    },
    active_zones: {
      immediate: true,
      handler(zones) {
        if (Array.isArray(zones)) {
          this.zoneList = zones;
        } else {
          this.zoneList = [];
        }
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      zoneList: [],
      localTeams: [
        {
          text: null,
          primary_zone: [],
          secondary_zone: [],
        },
      ],
    };
  },
  methods: {
    updateContractSetting() {

      const _this = this;

      const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }

      _this.pageLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url: "setting/team",
          data: { teams: _this.localTeams },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-teams", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createContractType() {
      this.localTeams.push({
        text: null,
        primary_zone: [],
        secondary_zone: [],
      });
    },
    deleteContractType(index) {
      if (this.localTeams.length > 1) {
        this.localTeams.splice(index, 1);
      }
    },
    // Returns zone names excluding those selected in this team's secondary_zone
    primaryZoneOptions(team) {
      const taken = Array.isArray(team.secondary_zone) ? team.secondary_zone : [];
      return this.zoneNames.filter((n) => !taken.includes(n));
    },
    // Returns zone names excluding those selected in this team's primary_zone
    secondaryZoneOptions(team) {
      const taken = Array.isArray(team.primary_zone) ? team.primary_zone : [];
      return this.zoneNames.filter((n) => !taken.includes(n));
    },
    onPrimaryChange(newVal, team) {
      if (!Array.isArray(newVal)) return;
      team.primary_zone = newVal;
      if (!Array.isArray(team.secondary_zone)) team.secondary_zone = [];
      team.secondary_zone = team.secondary_zone.filter((s) => !newVal.includes(s));
    },
    onSecondaryChange(newVal, team) {
      if (!Array.isArray(newVal)) return;
      team.secondary_zone = newVal;
      if (!Array.isArray(team.primary_zone)) team.primary_zone = [];
      team.primary_zone = team.primary_zone.filter((p) => !newVal.includes(p));
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
    zoneNames() {
      return Array.isArray(this.zoneList) ? this.zoneList.map((z) => z.name) : [];
    },

    duplicateTeamMessage() {

     

      const texts = this.localTeams
        .map(item => item.text?.trim().toLowerCase())
        .filter(Boolean);

      const duplicate = texts.find(
        (text, index) => texts.indexOf(text) !== index
      );

    return duplicate ? "Team already exists." : "";

  },

    isSaveDisabled() {
    
      const hasEmpty = this.localTeams.some(
        (item) => !item.text || item.text.trim() === ""
      );

      if (hasEmpty) return true;
 
      const texts = this.localTeams.map((item) =>
        item.text.trim().toLowerCase()
      );

      const hasDuplicate = texts.some(
        (text, index) => texts.indexOf(text) !== index
      );

      if (hasDuplicate) return true;
 
      return false;

    },

  },
};
</script>
